import Vue from "vue";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import EditModal from "./edit/modal/edit_modal.controller";
import { handleError } from '../../../api';

Vue.use(Toasted, { duration: 2000 });

type IdName = {
    id: number;
    name: string;
    clone(): IdName;
}

type API = {
    create(value: IdName): Promise<IdName>,
    update(value: IdName): Promise<IdName>,
    delete(id: number): Promise<void>,
}

@Component({
    name: 'AbstractIdName',
    components: {
        VueGoodTable,
        EditModal: require('./edit/modal/edit_modal.vue.html').default
    }
})
export default class AbstractIdName extends Vue {
    @Prop({ required: true })
    type!: string;
    @Prop({ required: true })
    data!: IdName[];
    @Prop({ required: true })
    api!: API;
    @Prop({ required: true })
    objectInstanciator!: (init?: { id: number, name: string }) => IdName;

    //runtime
    editData?: IdName = {} as IdName;

    //config
    readonly columns = [
        {
            label: 'Id',
            field: 'id',
        },
        {
            label: 'Name',
            field: 'name',
        }
    ];
    selectConfig = {};

    initNew(): void {
        this.editData = this.objectInstanciator({ id: 0, name: '' });
    }

    initEdit(row: IdName): void {
        this.editData = row.clone();
    }

    save(): void {
        if (!this.editData)
            return;
        if (this.editData.id < 1) {
            this.api.create(this.editData)
                .then(r => {
                    this.$toasted.info(this.$t('txtSaved').toString());
                    this.data.push(r);
                    (this.$refs.modal as EditModal).forceClose();
                })
                .catch(err => handleError(this.$toasted, this.$i18n, err));
        } else {
            let id = this.editData.id;
            this.api.update(this.editData)
                .then(r => {
                    this.$toasted.info(this.$t('txtSaved').toString());
                    let i = this.data.findIndex(e => e.id === id);
                    if (i !== undefined) {
                        this.data.splice(i, 1, r);
                    }
                    (this.$refs.modal as EditModal).forceClose();
                })
                .catch(err => handleError(this.$toasted, this.$i18n, err));
        }
    }

    onClick(arg: { row: IdName, pageIndex: number, selected: boolean, event: MouseEvent }): void {
        this.initEdit(arg.row);
        (this.$refs.modal as EditModal).forceOpen();
    }
}